import ModelData from "./model_data";
import ModuleManager from "../../framework/core/module_manager";
import DialogTips from "./module/dialog_tips/dialog_tips";
import GameUtil from "../../utility/game_util";
import AppData from "./const/app_data";
import HallServer from "../hall/server/hall/hall_serve";
import SceneManager from "../../manager/scene_manager";
import { IUserCurrencyData } from "../../manager/user_manager";
import Module from "../../framework/core/mvvm/module_base";
import { TaskHelp } from "../hall/module/gametask/task_help";
import EventManager from "../../manager/event_manager";
import ActivityUtil from "../hall/module/activity/activity_util";
import MVVMBase from "../../framework/core/mvvm/mvvm_base";
import GoldEntranceModule from "../hall/module/goldentrance/hundred/goldentrance";
import GoldEntranceMatching from "../hall/module/goldentrance/goldentrance_matching";
import LanguageManager from "../../manager/language_manager";
import Dialog from "./module/dialog/dialog";
import NetPrompt from "./module/netprompt/netprompt";
import GameServer from "../hall/server/gameserver/game_server";
import { DayWelFareModule } from "../hall/module/daywelfare/day_welfare_module";
import { QuickBuy } from "../hall/module/quickbuy/quick_buy";
import FirstCharge from "../hall/module/firstcharge/firstcharge";
import TimeManager from "../../manager/time_manager";


export enum joinResult {

    none,
    /**
     * 充值
     */
    showRecharge,
    /**
     * 加入当前房间
     */
    joinCurrent,
    /**
     * 转场弹窗
     */
    changeRoomTips,
}


export class JoinUtil {

    private chip: number;
    private chipClub: number;

    private multipleGold: number;

    private dataList: any[];

    private lastOpenGoldEntraceModuleName: string = null
    private lastOpenGoldEntraceModuleNum = 0
    private lastOpenGoldEntraceModuleTime = 0

    public recentGame: string;

    private markTime: number;

    constructor() {

        this.chip = 0;
        this.chipClub = 0;
        EventManager.instance.on("refresh_user_money", this.onRefreshUserMoney, this, true)
        EventManager.instance.on("refresh_multiple_gold", this.onMultipleGoldChange, this, true)
    }

    private onRefreshUserMoney(data: IUserCurrencyData) {

        console.warn(" onRefreshUserMoney ", data.chip, " chipClub ", data.chipClub);
        this.chip = data.chip;
        this.chipClub = data.chipClub;

        this.multipleGold = ModelData.instance.clubId ? this.chipClub : this.chip;
    }

    private onMultipleGoldChange(num: number) {

        this.multipleGold = num;
    }

    /**
     * 是否满足离场条件
     * @param reason 
     * @param module 
     */
    public checkLeave(reason: number, module: MVVMBase) {

        //筹码不够小于离场下限,需要充值 / 筹码太多超过离场上限,需要转场    
        if ((reason == -888 || reason == -886) && !ModelData.instance.tableCommonData.isClubTable) {

            //EventManager.instance.dispatch("event_avatar_leave", goldId, module)            
            joinUtil.checkInMatchingTable(module);
            GameServer.instance.close()

            return true;
        } else if (reason) {
            ModuleManager.instance.showModule(DialogTips, { Content: LanguageManager.t("server_error_" + reason), titleError: true })
        }

        return false;
    }


    public updateRoomData(dataList: any[]) {

        this.dataList = dataList;
    }

    /**
     * 首充
     * @param state 
     */
    private getFirstCharge(mvvmBase: MVVMBase, callback: (result: boolean) => void) {

        ActivityUtil.isReceiveFirstCharge((isHave) => {

            cc.log(" getFirstCharge isHave ", isHave);
            if (callback) {
                callback(isHave);
            }
        }, mvvmBase);

    }

    /**
     * 每日签到
     * @param mvvmBase 
     * @param callback 
     */
    public getDailySign(mvvmBase: MVVMBase, callback: (result: boolean) => void) {

        //每日签到
        ActivityUtil.getDailySignData((dataMap) => {

            if (dataMap) {

                let dailyDataMap = dataMap.dailyDataMap
                let result = dailyDataMap.currentConditionGroup > 0 && dailyDataMap.isReceive && (!dailyDataMap.isFinish);

                if (callback) {
                    callback(result);
                }
            } else {
                callback(false);
            }

        }, mvvmBase);
    }

    /**
     * 破产转盘
     * @param mvvmBase 
     */
    public isHaveDayWelfare(mvvmBase: MVVMBase, callback: (result: boolean) => void) {


        TaskHelp.isHaveDayWelfare((isHave: boolean) => {
            if (callback) {
                callback(isHave);
            }
        }, mvvmBase)
    }

    private getCurrency(actType: number, module: MVVMBase, callback: (currency: number) => void) {

        let self = this;
        module.getSelfCurrencyData((currencyData: IUserCurrencyData) => {

            self.chip = currencyData.chip;
            self.chipClub = currencyData.chipClub;

            let currency = actType == 200 ? this.chipClub : this.chip;

            if (callback) {
                callback(currency);
            }

        }, true, true)

    }

    /**
     *  匹配场离场
     * @param module 
     * @param isMultiple 是否为百人场
     */
    public checkInMatchingTable(module: MVVMBase) {

        let self = this;
        ModuleManager.instance.showModule(NetPrompt);

        this.getDataList(module, (dataList: any) => {

            if (!dataList) {
                SceneManager.gotoHall();
                return;
            }
            //筹码不够小于离场下限,需要充值 / 筹码太多超过离场上限,需要转场       
            let curGoldId = ModelData.instance.tableCommonData.goldFildId;
            let recommentData: { fully: boolean, roomData: any } = null;

            let curRoom = self.findRoomById(curGoldId);

            let curRule = JSON.parse(curRoom.playRule);

            this.getCurrency(curRoom.accountType, module, (currency) => {

                ModuleManager.instance.hideModule("NetPrompt");
                recommentData = self.findRecommend(currency, curRoom);
                if (recommentData) {
                    if (recommentData.roomData.gameGoldId == curGoldId) {
                        if (AppData.testMode) {
                            ModuleManager.instance.toast("当前的场次就是推荐的场次,不需要离场,请检查离场、准入配置")
                        }
                    } else {
                        //判断钱多了还是钱少了
                        let recomRule = JSON.parse(recommentData.roomData.playRule);
                        if (recomRule.pub_AllowNum < curRule.pub_AllowNum) {
                            //钱不够了,需要转低等级的场次
                            //尊贵的客人，您的筹码不足(场次最低限额{0}),请选择合适的场次
                            self.tipInTable("join_coin_no_enough", curRule.pub_AllowNum, "join_coin_no_enough_title");

                        } else {
                            //钱太多了,需要转高等级的场次
                            self.tipInTable("join_coin_exceed", curRule.pub_AllowNumMax, "join_coin_exceed_title");
                        }
                    }
                } else {
                    //不存在推荐场次 余额不足 跳转到选场界面
                    self.tipInTable("join_coin_no_enough", curRule.pub_AllowNum, "join_coin_no_enough_title");
                }

            })

        });


    }


    private tipInTable(key: string, value: number, titleKey: string) {
        let text = LanguageManager.t(key).format(GameUtil.currencyFormat(value));
        let title = LanguageManager.t(titleKey);
        ModuleManager.instance.showModule<Dialog>(Dialog).show_center_button(title, text, () => {
            SceneManager.gotoHall();
        });
    }


    private getDataList(module: MVVMBase, callback: (dataList) => void) {

        let self = this;

        if (!this.dataList) {

            let requestData: IHttpRequestData = {
                baseUrl: "gold/getGameGolds?",
                showNetPrompt: false,
                timeOutRequestMax: 1,
                encrypt: true
            }

            module.apiHttpGet(requestData, (respone) => {

                if (respone.code == "SUCCESS") {
                    self.updateRoomData(respone.data);
                    callback(respone.data);
                }
            });

        } else {

            callback(this.dataList);
        }


    }

    //选场的底注
    public getBetStr(rule: any) {

        let betStr = "";
        switch (AppData.gameName) {
            case "TM_QZNN":
            case "TM_BP":
            case "TM_JK":
            case "TM_BPZD":
            case "TM_Q2":
            case "CLUB_QZNN":
            case "CLUB_BP":
            case "CLUB_JK":
            case "CLUB_BPZD":
            case "CLUB_Q2":
                betStr = GameUtil.currencyFormatting(rule.game_BetSingle);
                break;
            case "TM_JD":
            case "TM_HJK":
            case "CLUB_JD":
            case "CLUB_HJK":
                betStr = rule.game_SmallBlind ? GameUtil.currencyFormatting(rule.game_SmallBlind) : GameUtil.currencyFormatting(rule.game_BetMin);
                break;
            case "TM_DZPK":
            case "CLUB_DZPK":
                betStr = GameUtil.currencyFormatting(rule.game_SmallBlind) + "/" + GameUtil.currencyFormatting(rule.game_BigBlind);
                break;
            case "TM_SLOT":
            case "CLUB_SLOT":
                betStr = GameUtil.currencyFormatting(rule.minMultiple) + "/" + GameUtil.currencyFormatting(rule.maxMultiple);
                break;
            default:
                break;
        }

        return betStr;
    }

    /**
     * 匹配场、百人场游戏外弹窗
     * @param module 
     * @param isMultiple 是否为百人场
     * @param data isMultiple = true data传 准入值/最小下注值(牌桌内传最小下注) isMultiple = false data传场次数据
     */
    showRecharge(module: MVVMBase, isMultiple: boolean, data: any) {

        let self = this;
        this.isHaveDayWelfare(module, (turntable) => {
            //转盘
            if (turntable) {
                let callbackFunc = function () {

                    if (isMultiple) {
                        if (self.chipClub < data) {
                            self.checkRechargeStep2(module);
                        }
                    } else {
                        //匹配场 如果还是没有推荐的房间
                        let find = self.findRecommend(self.chipClub, data);
                        if (!find) {
                            self.checkRechargeStep2(module);
                        }
                    }
                }
                ModuleManager.instance.showModule(DayWelFareModule, { hideCallback: callbackFunc });
            } else {
                self.checkRechargeStep2(module);
            }
        })
    }

    /**
     * 百人场游戏内充值弹窗
     * @param module 
     */
    showRechargeInMultiple(module: MVVMBase) {

        if (ModelData.instance.tableCommonData.isClubTable) {
            return;
        }

        if (this.rechargePopState) {
            return;
        }

        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.markTime > 0 && this.markTime + 1 > AppRunningTime) {
            return
        }
        this.markTime = AppRunningTime

        let self = this;
        this.isHaveDayWelfare(module, (turntable) => {
            //转盘
            if (turntable) {

                let rule = ModelData.instance.roomInfo.PlayRuleData;
                let betValue = rule.game_BetArr && rule.game_BetArr.length > 0 ? rule.game_BetArr[0] : 0;
                let allowNum = rule.pub_AllowNum ? rule.pub_AllowNum : 0;

                let callbackFunc = function () {
                    //这里是百人场本人的当前余额
                    if (self.multipleGold < betValue + allowNum) {
                        self.checkRechargeStep2(module);
                    }
                }

                if (this.rechargePopState) {
                    return;
                }
                ModuleManager.instance.showModule(DayWelFareModule, { hideCallback: callbackFunc });

            } else {
                self.checkRechargeStep2(module);
            }
        })
    }


    private get rechargePopState() {

        let wellState = ModuleManager.instance.moduleInLoading("DayWelFareModule") || ModuleManager.instance.moduleHasActive("DayWelFareModule");
        let firstState = ModuleManager.instance.moduleInLoading("FirstCharge") || ModuleManager.instance.moduleHasActive("FirstCharge");
        let quickBuyState = ModuleManager.instance.moduleInLoading("QuickBuy") || ModuleManager.instance.moduleHasActive("QuickBuy");

        return wellState || firstState || quickBuyState;

    }


    private checkRechargeStep2(module: MVVMBase) {

        //是否有首充
        this.getFirstCharge(module, (first) => {
            if (first) {
                if (this.rechargePopState) {
                    return;
                }
                ModuleManager.instance.showModule(FirstCharge);
            } else {
                //快捷礼包
                if (this.rechargePopState) {
                    return;
                }

                ActivityUtil.isHaveQuickBuy(() => {
                    ModuleManager.instance.showModule(QuickBuy);
                }, module)

            }
        });
    }

    private findRoomById(gameGoldId: number): any {

        if (!this.dataList) {
            cc.error(" datalist is null !");
            return null;
        }

        for (let index = 0; index < this.dataList.length; index++) {
            const roomData = this.dataList[index];
            if (roomData.gameGoldId == gameGoldId) {

                return roomData;
            }
        }

        return null;
    }

    public findRecommend(currency: number, checkRoom: any): { fully: boolean, roomData: any } {

        if (!checkRoom) {
            return null
        }

        //搜索 余额≥入场min 入场min最高的场次
        let findData: { fully: boolean, roomData: any } = null;

        if (!this.dataList) {
            return null;
        }


        let allowNum = 0;


        for (let index = 0; index < this.dataList.length; index++) {
            let dataRoom = this.dataList[index];

            //需要相同场次 相同的游戏类型(前注/后注/普通)
            if (AppData.gameName == "TM_DZPK") {
                if (checkRoom.accountType != dataRoom.accountType
                    || checkRoom.playTag != dataRoom.playTag) {
                    continue;
                }
            } else if (AppData.gameName == "TM_QZNN") {
                let rule1 = JSON.parse(checkRoom.playRule)
                let rule2 = JSON.parse(dataRoom.playRule)
                if (rule1.kanPaiCount != rule2.kanPaiCount) {
                    continue;
                }
            }


            let dataRule = JSON.parse(dataRoom.playRule);

            allowNum = findData && findData.roomData ? JSON.parse(findData.roomData.playRule).pub_AllowNum : 0;
            if (dataRule.pub_AllowNum <= currency &&
                dataRule.pub_AllowNum >= allowNum) {

                findData = { fully: false, roomData: dataRoom };
            }
        }

        return findData;
    }




    joinMatch(roomData: any, currency: number, roomIx?: number) {

        let roomRule = JSON.parse(roomData.playRule);

        //判断钱够不够
        if (roomRule.pub_AllowNum > currency) {
            //筹码不足(场次最低限额{0}),  请选择合适的场次
            let text = LanguageManager.t("join_coin_no_enough_tip",AppData.testMode).format(GameUtil.currencyFormat(roomData.minJoinCoin));
            ModuleManager.instance.toast(text);
            return
        }

        if (roomRule.pub_AllowNumMax && roomRule.pub_AllowNumMax < currency) {

            //筹码太多(场次最高限额{0}),  请选择合适的场次 
            let text = LanguageManager.t("join_coin_exceed_tip",AppData.testMode).format(GameUtil.currencyFormat(roomData.maxJoinCoin));
            ModuleManager.instance.toast(text);
            return
        }


        let goldId = roomData.gameGoldId ? roomData.gameGoldId : roomData.goldId;
        ModelData.instance.tableCommonData.roomRuleData = roomData;
        ModelData.instance.tableCommonData.isClubTable = ModelData.instance.clubId > 0;
        ModelData.instance.tableCommonData.goldFildId = goldId;

        ModelData.instance.tableCommonData.autoLeaveWhenGameEnd = false

        ModuleManager.instance.hideModule("NetPrompt");


        switch (AppData.gameName) {
            case "TM_BPZD":
            case "TM_BP":
            case "TM_QZNN":
            case 'TM_JK':
            case "TM_HJK":
            case "TM_JD":
            case "TM_Q2":
            case "CLUB_BPZD":
            case "CLUB_BP":
            case "CLUB_QZNN":
            case 'CLUB_JK':
            case "CLUB_HJK":
            case "CLUB_JD":
            case "CLUB_Q2":
                HallServer.instance.joinRoom(0, () => {
                }, JSON.stringify({ coin: roomRule.minJoinCoin, auto_recharge: 0 }), roomIx, goldId, 1);
                break;
            case "TM_SLOT":
            case "CLUB_SLOT":
                let join = function (carry) {
                    HallServer.instance.joinRoom(
                        0,
                        null,
                        JSON.stringify({ coin: carry }),
                        roomIx,
                        goldId,
                        1);
                }
                let minGold = roomRule.payLineNumber * roomRule.minMultiple + 10
                let maxGold = roomRule.payLineNumber * roomRule.maxMultiple * 100
                let carryGold = 0
                if (currency >= maxGold) {
                    carryGold = Math.floor(maxGold / 2)
                    join(carryGold)
                } else if (currency >= 2 * minGold && currency < maxGold) {
                    carryGold = Math.floor(currency / 2)
                    join(carryGold)
                } else if (currency < 2 * minGold && currency >= minGold) {
                    carryGold = Math.floor(currency)
                    join(carryGold)
                } else {
                    cc.log("金币不足，无法进入")
                }
                break;
            case "TM_DZPK":
            case "CLUB_DZPK":
                let data = {
                    min: roomRule.game_BetTakeMin,
                    max: roomRule.game_BetTakeMax,
                    lockGold: 0,
                    bigBlind: roomRule.game_BigBlind || 0,
                    callFunc: function (minV, autoBuy) {
                        HallServer.instance.joinRoom(
                            0,
                            null,
                            JSON.stringify({ coin: minV, auto_recharge: autoBuy }),
                            roomIx,
                            goldId,
                            1);
                    },
                    isMongo: false,
                }
                ModuleManager.instance.showModuleName('TexasChips', data);
                break;

        }
    }

    joinMultiple(playRule: any, currency: number, roomId: number, callback?, exJsonStr?: string, roomIx?: number, goldFieldID?: number, channelID?: number) {

        if (playRule.pub_AccountType != 200) {
            let minBet = playRule.game_BetArr && playRule.game_BetArr.length > 0 ? playRule.game_BetArr[0] : 0;
            let allowNum = playRule.pub_AllowNum ? playRule.pub_AllowNum : 0;
            let allowValue = Math.max(minBet, allowNum);
    
            if (currency < allowValue) {
    
                let text = LanguageManager.t("join_coin_no_enough_tip").format(GameUtil.currencyFormat(allowValue));
                ModuleManager.instance.toast(text);
                return;
            }
        }
        HallServer.instance.joinRoom(roomId, callback, exJsonStr, roomIx, goldFieldID, channelID);
    }

    public openGoleEntrance(gameName, openMango: boolean = false) {

        let hall: Module<null, null> = ModuleManager.instance.getModule("Hall");
        if (!hall || !hall.nodeIsActive || !gameName) {
            return;
        }
        let gameDataShow = ModelData.instance.getGameDataShow(gameName)
        if (gameDataShow && gameDataShow.openLevel && ModelData.instance.roleData.userLevel < gameDataShow.openLevel && !AppData.startCheckGame) {
            ModuleManager.instance.toast(LanguageManager.t("pubilc_levelLock").format(gameDataShow.openLevel))
            return
        }

        let moduleType = null
        switch (gameName) {
            case "TM_BJL"://百家乐
            case "TM_LHD"://龙虎斗
            case "TM_YXX"://鱼虾蟹
            case "TM_TB"://骰宝 
            case "TM_CP"://彩票
            case "CLUB_BJL"://百家乐
            case "CLUB_LHD"://龙虎斗
            case "CLUB_YXX"://鱼虾蟹
            case "CLUB_TB"://骰宝 
            case "CLUB_CP"://彩票
                moduleType = GoldEntranceModule
                break

            case "TM_JD"://九点
            case "TM_HJK"://21点
            case "TM_BP"://比牌
            case "TM_BPZD":
            case "TM_QZNN"://牛牛
            case "TM_DZPK"://德州扑克
            case "TM_JK"://9K
            case "TM_Q2"://Q2
            case "TM_SLOT":
            case "CLUB_JD"://九点
            case "CLUB_HJK"://21点
            case "CLUB_BP"://比牌
            case "CLUB_BPZD":
            case "CLUB_QZNN"://牛牛
            case "CLUB_DZPK"://德州扑克
            case "CLUB_JK"://9K
            case "CLUB_Q2"://Q2
            case "CLUB_SLOT":
                moduleType = GoldEntranceMatching
                break
            // case "TM_SLOT":
            //     AppData.gameName = "TM_SLOT"
            //     SceneManager.loadingTableModule(null, () => {

            //     })
            //     break;

        }
        if (moduleType != null) {
            let self = this
            if (Date.now() - this.lastOpenGoldEntraceModuleTime < 1000) { //防止在播放动画的过程中被点击触发了意外情况
                return
            }

            this.recentGame = gameName;


            //cc.log("this.latOpenGoldEntraceModuleName:",this.latOpenGoldEntraceModuleName);
            //TODO:多次同时调用是会有问题的，因为是异步
            if (this.lastOpenGoldEntraceModuleName) {
                ModuleManager.instance.hideModule(this.lastOpenGoldEntraceModuleName)
            }
            this.lastOpenGoldEntraceModuleName = moduleType.moduleClass
            let _latOpenGoldEntraceModuleNum = ++this.lastOpenGoldEntraceModuleNum
            AppData.gameName = gameName;

            ModuleManager.instance.showModule(moduleType, !openMango ? "HallShowGoldEntrance" : "ShowMango", (module: GoldEntranceMatching | GoldEntranceModule, state: boolean) => {
                if (state && _latOpenGoldEntraceModuleNum == self.lastOpenGoldEntraceModuleNum) {
                    self.lastOpenGoldEntraceModuleTime = Date.now()
                    EventManager.instance.dispatch("hall_show_type", "HideHall", true)

                    hall.doScheduleOnce(() => {
                        //事件太多，好麻烦
                        EventManager.instance.dispatch("goldentrance_show_type", "HallShowGoldEntrance")
                        module.tweenShowView("HallShowGoldEntrance")
                        if (ModuleManager.instance.moduleHasActive(moduleType.moduleClassName)) {
                            hall.hide();
                        }
                    }, 0.3)
                } else {

                }
            })
        }
    }

    public getRoomName(pub_roomType: number) {

        let roomName = "unknow";
        switch (pub_roomType) {
            case 1:
                roomName = LanguageManager.t("public_chuRoom");
                break;
            case 2:
                roomName = LanguageManager.t("public_zhonRoom");
                break;
            case 3:
                roomName = LanguageManager.t("public_gaoRoom");
                break;
            case 4:
                roomName = LanguageManager.t("public_zhizunRoom");
                break;
            case 5:
                roomName = LanguageManager.t("public_wangzheRoom");
                break;
        }

        return roomName;
    }


    /**
     * 是否为百人场
     * @param gameName 
     */
    public isMultiple(gameName: string) {

        let matchNameList = ["TM_BPZD", "TM_BP", "TM_QZNN", "TM_JK", "TM_HJK", "TM_JD", "TM_Q2", "TM_SLOT", "TM_DZPK",
            "CLUB_BPZD", "CLUB_BP", "CLUB_QZNN", "CLUB_JK", "CLUB_HJK", "CLUB_JD", "CLUB_Q2", "CLUB_SLOT", "CLUB_DZPK"];

        let isMatch = false;

        for (let index = 0; index < matchNameList.length; index++) {
            const name = matchNameList[index];

            if (name == gameName) {
                isMatch = true;
                break;
            }
        }

        return !isMatch;

    }


}



export let joinUtil: JoinUtil = new JoinUtil();